import React, { useState, useEffect } from 'react';
import config from './Config';
import MessageParser from './MessageParser';
import ActionProvider from './ActionProvider';
import Chatbot from 'react-chatbot-kit';
import 'react-chatbot-kit/build/main.css';
import styled from 'styled-components';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseIcon from '@mui/icons-material/Close';
import propTypes from 'prop-types';
const ChatbotContainer = styled.div`
    .react-chatbot-kit-chat-container {
        width: 400px;
    }

    .react-chatbot-kit-chat-inner-container {
        background-color: #fafbf7;
    }

    .react-chatbot-kit-chat-header {
    }

    .react-chatbot-kit-chat-input-container {
    }

    .react-chatbot-kit-chat-message-container {
    }

    .react-chatbot-kit-chat-input {
    }

    .react-chatbot-kit-chat-input-form {
    }

    .react-chatbot-kit-chat-input::placeholder {
    }

    .react-chatbot-kit-chat-btn-send {
    }

    .react-chatbot-kit-chat-btn-send-icon {
    }

    .react-chatbot-kit-chat-bot-message-container {
        .react-chatbot-kit-chat-bot-message {
            height: 100%;
            width: 100%;
        }
    }

    .react-chatbot-kit-chat-bot-avatar-container {
        border: 3px solid red;
    }

    .react-chatbot-kit-chat-bot-avatar-icon {
        border: 3px solid red;
    }

    .react-chatbot-kit-chat-bot-avatar-letter {
    }

    .react-chatbot-kit-chat-bot-message {
    }

    .react-chatbot-kit-chat-bot-message-arrow {
    }

    .react-chatbot-kit-chat-bot-loading-icon-container {
    }

    .chatbot-loader-container {
    }

    #chatbot-loader #chatbot-loader-dot1 {
    }

    #chatbot-loader #chatbot-loader-dot2 {
    }

    #chatbot-loader #chatbot-loader-dot3 {
    }

    .react-chatbot-kit-error {
    }

    .react-chatbot-kit-error-container {
    }

    .react-chatbot-kit-error-header {
    }

    .react-chatbot-kit-error-docs {
    }
`;

const CollapseButton = styled.div`
    color: white;

    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    :hover {
        border: 1px solid white;
        cursor: pointer;
    }
`;

const MinMaxButton = styled.div`
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    :hover {
        border: 1px solid white;
        cursor: pointer;
    }
`;

const ButtonContainer = styled.div`
    display: flex;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    left: 310px;
    bottom: -40px;
    height: 35px;
    width: 80px;
    z-index: 1; /* Set the z-index to a lower value */
    justify-content: space-evenly;
`;
const StyledChatBot = ({ setBotIsOpen }) => {
    const [isMax, setIsMax] = useState(false);

    const minHandler = () => {
        setIsMax(!isMax);
    };

    const determineStyle = () => {
        let chatbot = document.getElementsByClassName('react-chatbot-kit-chat-container');
        let buttonCon = document.getElementsByClassName('buttonContainer');

        if (isMax) {
            if (chatbot.length > 0) {
                // Access the first element in the collection (index 0) and change its CSS
                chatbot[0].style.width = '800px';
                buttonCon[0].style.left = '710px';
            }
        } else {
            if (chatbot.length > 0) {
                // Access the first element in the collection (index 0) and change its CSS
                chatbot[0].style.width = '400px';
                buttonCon[0].style.left = '310px';
            }
        }
    };

    useEffect(() => {
        determineStyle();
    }, [isMax]);

    return (
        <ChatbotContainer>
            <ButtonContainer className="buttonContainer">
                <MinMaxButton onClick={() => minHandler()}>
                    {isMax ? <CloseFullscreenIcon /> : <OpenInFullIcon />}
                </MinMaxButton>
                <CollapseButton onClick={() => setBotIsOpen(false)}>
                    <CloseIcon />
                </CollapseButton>
            </ButtonContainer>

            <Chatbot
                config={config}
                headerText="Chat with your expert, davie!"
                placeholderText="Ask a Question"
                messageParser={MessageParser}
                actionProvider={ActionProvider}
            />
        </ChatbotContainer>
    );
};

StyledChatBot.propTypes = {
    setBotIsOpen: propTypes.func,
};

export default StyledChatBot;
